import { render, staticRenderFns } from "./email_cstl.vue?vue&type=template&id=ce271fc6&"
import script from "./email_cstl.vue?vue&type=script&lang=js&"
export * from "./email_cstl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports